<template>
  <v-card style="height: calc(100vh - 120px); margin: 0px 20px">
    <v-select
      v-if="listTitoli.length > 0"
      v-model="selected"
      :items="listTitoli"
      item-text="text"
      item-value="key"
      color="primary"
      solo
    ></v-select>
    <v-row v-if="selected === 'index'">
      <v-col>
        <v-list-item v-for="titolo in listTitoli" :key="titolo.key">
          <v-list-item-content v-if="titolo.key !== 'index'">
            <v-list-item-title>
              <v-btn
                class="sm-12"
                style="width: 100%"
                outlined
                color="primary"
                @click="selected = titolo.key"
              >
                {{ titolo.text }}
              </v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <object
          :data="url(selected)"
          style="
            height: calc(100% - 50px);
            width: 100%;
            top: 50px;
            position: absolute;
          "
        ></object>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "guidaGlobale",
  components: {},
  data() {
    return {
      panel: null,
      selected: null,
    };
  },
  mounted() {
    //this.selected = this.listTitoli[0];
    this.selected = "index";
  },
  computed: {
    listRoute() {
      let rotte = this.$router.options.routes.filter((rotta) => {
        return rotta.path === "/portal";
      });
      return rotte[0].children;
    },
    listTitoli() {
      let list = [];
      if (
        window &&
        window.selectedLanguage &&
        window.systemData &&
        window.systemData.help &&
        window.systemData.help[window.selectedLanguage] &&
        window.systemData.help[window.selectedLanguage]["general"]
      )
        list = window.systemData.help[window.selectedLanguage]["general"].map(
          (doc) => {
            return { key: doc.title, text: doc.title };
          }
        );
      list.unshift({ key: "index", text: this.$t("help_index") });
      return list;
    },
  },
  methods: {
    url(titolo) {
      return "/API/public/portal/getTitleHelp?title=" + titolo;
    },
  },
};
</script>